import { createContext } from "react";
import openSocket from "socket.io-client";
import { getBackendUrl } from "../../config";
import { getFrontendBackendBaseUrl, normalizeUrlsDeep } from "../../helpers/normalizeUrls";
// import config from "../../services/config";

const socketManager = {
	currentSocket: null,

	GetSocket: function () {
		const publicToken = localStorage.getItem("public-token");

		if (publicToken !== this.currentToken) {
			if (this.currentSocket) {
				this.currentSocket.disconnect();
			}

			this.currentToken = publicToken;
			this.currentSocket = openSocket(getBackendUrl() || process.env.REACT_APP_BACKEND_URL, {
				transports: ["websocket"],
				pingTimeout: 18000,
				pingInterval: 18000,
				query: publicToken ? { token: publicToken } : {},
				// auth: publicToken ? { token: publicToken } : {},
			});

			// Normalize any URLs arriving via socket events (prevents localhost URLs in production)
			const originalOn = this.currentSocket.on.bind(this.currentSocket);
			this.currentSocket.on = (event, callback) => {
				return originalOn(event, (...args) => {
					try {
						const backendBase = getFrontendBackendBaseUrl();
						if (args && args.length > 0) {
							args[0] = normalizeUrlsDeep(args[0], backendBase);
						}
					} catch (e) {
						// no-op
					}
					return callback(...args);
				});
			};
		}
		return this.currentSocket;
	},

	onConnect: function (callbackConnect) {
		if (this.currentSocket && this.currentSocket.connected) {
			callbackConnect();
		}
		this.currentSocket.on("connect", callbackConnect);
	},
};

const SocketContext = createContext()

export { SocketContext, socketManager };
